import axios from 'axios';
import _ from 'lodash';
import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';

const ax = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 2000,
  headers: {
    Authorization: `Bearer ${authService.getToken()}`,
  },
});

export function updateProfileContactDetails(
  influencerID,
  name,
  email,
  contactNumber,
  addressLine1,
  city,
  region,
  postalCode,
  country,
  agentName,
  agentEmail,
  agentContactNumber,
) {
  const patch = {
    data: {
      attributes: {
        name,
        email,
        contactNumber,
        addressLine1,
        city,
        region,
        postalCode,
        country,
        agentName,
        agentEmail,
        agentContactNumber,
      },
    },
  };

  ax.patch(`/influencer/${influencerID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencer', e);
  });
}

export function updateProfileSocialDetails(
  influencerID,
  facebook,
  facebookCount,
  instagram,
  instagramCount,
  twitter,
  twitterCount,
  youtube,
  youtubeCount,
  twitch,
  web,
  snapchat,
  pinterest,
  linkedin,
  tiktok,
  tiktokCount,
) {
  const patch = {
    data: {
      attributes: {
        facebook,
        facebookCount,
        instagram,
        instagramCount,
        twitter,
        twitterCount,
        youtube,
        youtubeCount,
        twitch,
        web,
        snapchat,
        pinterest,
        linkedin,
        tiktok,
        tiktokCount,
      },
    },
  };

  ax.patch(`/influencer/${influencerID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencer', e);
  });
}

export function updateProfileTags(
  influencerDetailsID,
  contentTags,
  brandTags,
) {
  const contentTagsSplit = _.split(contentTags, ',');
  const contentTagArray = _.map(contentTagsSplit, tag => _.trim(tag));
  const brandTagsSplit = _.split(brandTags, ',');
  const brandTagArray = _.map(brandTagsSplit, tag => _.trim(tag));

  const patch = {
    data: {
      attributes: {
        contentTags: contentTagArray,
        brandTags: brandTagArray,
      },
    },
  };

  ax.patch(`/influencerDetails/${influencerDetailsID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencr details', e);
  });
}

export function updateDescription(
  influencerDetailsID,
  description,
) {
  const patch = {
    data: {
      attributes: {
        description,
      },
    },
  };

  ax.patch(`/influencerDetails/${influencerDetailsID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencr details', e);
  });
}

export function updatePayments(
  influencerID,
  paypalEmail,
  discountCode,
) {
  const patch = {
    data: {
      attributes: {
        paypalEmail,
        discountCode,
      },
    },
  };

  ax.patch(`/influencer/${influencerID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencer', e);
  });
}


export function updateDemographics(
  influencerID,
  { gender, ageBracket, ethnicity },
) {
  const patch = {
    data: {
      attributes: {
        gender,
        ageBracket,
        ethnicity,
      },
    },
  };

  ax.patch(`/influencer/${influencerID}`, patch).then(r => r.data).catch(e => {
    reportError('Can not patch influencer demographics', e);
  });
}



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/utils.js
 **/